module.exports = __webpack_public_path__ + "img/honor.40f65380.jpg";